const keyboardMap = {
	0x01: 'Keyboard ErrorRollOver',
	0x02: 'Keyboard POSTFail',
	0x03: 'Keyboard ErrorUndefined',
	0x04: 'Keyboard a and A',
	0x05: 'Keyboard b and B',
	0x06: 'Keyboard c and C',
	0x07: 'Keyboard d and D',
	0x08: 'Keyboard e and E',
	0x09: 'Keyboard f and F',
	0x0A: 'Keyboard g and G',
	0x0B: 'Keyboard h and H',
	0x0C: 'Keyboard i and I',
	0x0D: 'Keyboard j and J',
	0x0E: 'Keyboard k and K',
	0x0F: 'Keyboard l and L',
	0x10: 'Keyboard m and M',
	0x11: 'Keyboard n and N',
	0x12: 'Keyboard o and O',
	0x13: 'Keyboard p and P',
	0x14: 'Keyboard q and Q',
	0x15: 'Keyboard r and R',
	0x16: 'Keyboard s and S',
	0x17: 'Keyboard t and T',
	0x18: 'Keyboard u and U',
	0x19: 'Keyboard v and V',
	0x1A: 'Keyboard w and W',
	0x1B: 'Keyboard x and X',
	0x1C: 'Keyboard y and Y',
	0x1D: 'Keyboard z and Z',
	0x1E: 'Keyboard 1 and !',
	0x1F: 'Keyboard 2 and @',
	0x20: 'Keyboard 3 and #',
	0x21: 'Keyboard 4 and $',
	0x22: 'Keyboard 5 and %',
	0x23: 'Keyboard 6 and ^',
	0x24: 'Keyboard 7 and &',
	0x25: 'Keyboard 8 and *',
	0x26: 'Keyboard 9 and (',
	0x27: 'Keyboard 0 and )',
	0x28: 'Keyboard Return (ENTER)',
	0x29: 'Keyboard ESCAPE',
	0x2A: 'Keyboard DELETE (Backspace)',
	0x2B: 'Keyboard Tab',
	0x2C: 'Keyboard Spacebar',
	0x2D: 'Keyboard - and (underscore)',
	0x2E: 'Keyboard = and +',
	0x2F: 'Keyboard [ and {',
	0x30: 'Keyboard ] and }',
	0x31: 'Keyboard \\ and |',
	0x32: 'Keyboard Non-US # and ~',
	0x33: 'Keyboard ; and :',
	0x34: 'Keyboard \' and "',
	0x35: 'Keyboard Grave Accent and Tilde',
	0x36: 'Keyboard, and <',
	0x37: 'Keyboard . and >',
	0x38: 'Keyboard / and ?',
	0x39: 'Keyboard Caps Lock',
	0x3A: 'Keyboard F1',
	0x3B: 'Keyboard F2',
	0x3C: 'Keyboard F3',
	0x3D: 'Keyboard F4',
	0x3E: 'Keyboard F5',
	0x3F: 'Keyboard F6',
	0x40: 'Keyboard F7',
	0x41: 'Keyboard F8',
	0x42: 'Keyboard F9',
	0x43: 'Keyboard F10',
	0x44: 'Keyboard F11',
	0x45: 'Keyboard F12',
	0x46: 'Keyboard PrintScreen',
	0x47: 'Keyboard Scroll Lock',
	0x48: 'Keyboard Pause',
	0x49: 'Keyboard Insert',
	0x4A: 'Keyboard Home',
	0x4B: 'Keyboard PageUp',
	0x4C: 'Keyboard Delete Forward',
	0x4D: 'Keyboard End',
	0x4E: 'Keyboard PageDown',
	0x4F: 'Keyboard RightArrow',
	0x50: 'Keyboard LeftArrow',
	0x51: 'Keyboard DownArrow',
	0x52: 'Keyboard UpArrow',
	0x53: 'Keypad Num Lock and Clear',
	0x54: 'Keypad /',
	0x55: 'Keypad *',
	0x56: 'Keypad -',
	0x57: 'Keypad +',
	0x58: 'Keypad ENTER',
	0x59: 'Keypad 1 and End',
	0x5A: 'Keypad 2 and Down Arrow',
	0x5B: 'Keypad 3 and PageDn',
	0x5C: 'Keypad 4 and Left Arrow',
	0x5D: 'Keypad 5',
	0x5E: 'Keypad 6 and Right Arrow',
	0x5F: 'Keypad 7 and Home',
	0x60: 'Keypad 8 and Up Arrow',
	0x61: 'Keypad 9 and PageUp',
	0x62: 'Keypad 0 and Insert',
	0x63: 'Keypad . and Delete',
	0x64: 'Keyboard Non-US \\ and |',
	0x65: 'Keyboard Application',
	0x66: 'Keyboard Power',
	0x67: 'Keypad =',
	0x68: 'Keyboard F13',
	0x69: 'Keyboard F14',
	0x6A: 'Keyboard F15',
	0x6B: 'Keyboard F16',
	0x6C: 'Keyboard F17',
	0x6D: 'Keyboard F18',
	0x6E: 'Keyboard F19',
	0x6F: 'Keyboard F20',
	0x70: 'Keyboard F21',
	0x71: 'Keyboard F22',
	0x72: 'Keyboard F23',
	0x73: 'Keyboard F24',
	0x74: 'Keyboard Execute',
	0x75: 'Keyboard Help',
	0x76: 'Keyboard Menu',
	0x77: 'Keyboard Select',
	0x78: 'Keyboard Stop',
	0x79: 'Keyboard Again',
	0x7A: 'Keyboard Undo',
	0x7B: 'Keyboard Cut',
	0x7C: 'Keyboard Copy',
	0x7D: 'Keyboard Paste',
	0x7E: 'Keyboard Find',
	0x7F: 'Keyboard Mute',
	0x80: 'Keyboard Volume Up',
	0x81: 'Keyboard Volume Down',
	0x82: 'Keyboard Locking Caps Lock',
	0x83: 'Keyboard Locking Num Lock',
	0x84: 'Keyboard Locking Scroll Lock',
	0x85: 'Keypad Comma',
	0x86: 'Keypad Equal Sign',
	0x87: 'Keyboard International1',
	0x88: 'Keyboard International2',
	0x89: 'Keyboard International3',
	0x8A: 'Keyboard International4',
	0x8B: 'Keyboard International5',
	0x8C: 'Keyboard International6',
	0x8D: 'Keyboard International7',
	0x8E: 'Keyboard International8',
	0x8F: 'Keyboard International9',
	0x90: 'Keyboard LANG1',
	0x91: 'Keyboard LANG2',
	0x92: 'Keyboard LANG3',
	0x93: 'Keyboard LANG4',
	0x94: 'Keyboard LANG5',
	0x95: 'Keyboard LANG6',
	0x96: 'Keyboard LANG7',
	0x97: 'Keyboard LANG8',
	0x98: 'Keyboard LANG9',
	0x99: 'Keyboard Alternate Erase',
	0x9A: 'Keyboard SysReq/Attention',
	0x9B: 'Keyboard Cancel',
	0x9C: 'Keyboard Clear',
	0x9D: 'Keyboard Prior',
	0x9E: 'Keyboard Return',
	0x9F: 'Keyboard Separator',
	0xA0: 'Keyboard Out',
	0xA1: 'Keyboard Oper',
	0xA2: 'Keyboard Clear/Again',
	0xA3: 'Keyboard CrSel/Props',
	0xA4: 'Keyboard ExSel',
	0xE0: 'Keyboard LeftControl',
	0xE1: 'Keyboard LeftShift',
	0xE2: 'Keyboard LeftAlt',
	0xE3: 'Keyboard Left GUI',
	0xE4: 'Keyboard RightControl',
	0xE5: 'Keyboard RightShift',
	0xE6: 'Keyboard RightAlt',
	0xE7: 'Keyboard Right GUI',
};

const keyboardModifiers = [
    [0x01, 'Left Control'],
    [0x02, 'Left Shift'],
    [0x04, 'Left Alt'],
    [0x08, 'Left Win'],
    [0x10, 'Right Control'],
    [0x20, 'Right Shift'],
    [0x40, 'Right Alt'],
    [0x80, 'Right Win'],
];

const consumerMap = {
	0x00: 'Unassigned',
	0x01: 'Consumer Control',
	0x02: 'Numeric Key Pad',
	0x03: 'Programmable Buttons',
	0x20: '+10',
	0x21: '+100',
	0x22: 'AM/PM',
	0x30: 'Power',
	0x31: 'Reset',
	0x32: 'Sleep',
	0x33: 'Sleep After',
	0x34: 'Sleep Mode',
	0x35: 'Illumination',
	0x36: 'Function Buttons',
	0x40: 'Menu',
	0x41: 'Menu  Pick',
	0x42: 'Menu Up',
	0x43: 'Menu Down',
	0x44: 'Menu Left',
	0x45: 'Menu Right',
	0x46: 'Menu Escape',
	0x47: 'Menu Value Increase',
	0x48: 'Menu Value Decrease',
	0x60: 'Data On Screen',
	0x61: 'Closed Caption',
	0x62: 'Closed Caption Select',
	0x63: 'VCR/TV',
	0x64: 'Broadcast Mode',
	0x65: 'Snapshot',
	0x66: 'Still',
	0x80: 'Selection',
	0x81: 'Assign Selection',
	0x82: 'Mode Step',
	0x83: 'Recall Last',
	0x84: 'Enter Channel',
	0x85: 'Order Movie',
	0x86: 'Channel',
	0x87: 'Media Selection',
	0x88: 'Media Select Computer',
	0x89: 'Media Select TV',
	0x8A: 'Media Select WWW',
	0x8B: 'Media Select DVD',
	0x8C: 'Media Select Telephone',
	0x8D: 'Media Select Program Guide',
	0x8E: 'Media Select Video Phone',
	0x8F: 'Media Select Games',
	0x90: 'Media Select Messages',
	0x91: 'Media Select CD',
	0x92: 'Media Select VCR',
	0x93: 'Media Select Tuner',
	0x94: 'Quit',
	0x95: 'Help',
	0x96: 'Media Select Tape',
	0x97: 'Media Select Cable',
	0x98: 'Media Select Satellite',
	0x99: 'Media Select Security',
	0x9A: 'Media Select Home',
	0x9B: 'Media Select Call',
	0x9C: 'Channel Increment',
	0x9D: 'Channel Decrement',
	0x9E: 'Media Select SAP',
	0xA0: 'VCR Plus',
	0xA1: 'Once',
	0xA2: 'Daily',
	0xA3: 'Weekly',
	0xA4: 'Monthly',
	0xB0: 'Play',
	0xB1: 'Pause',
	0xB2: 'Record',
	0xB3: 'Fast Forward',
	0xB4: 'Rewind',
	0xB5: 'Scan Next Track',
	0xB6: 'Scan Previous Track',
	0xB7: 'Stop',
	0xB8: 'Eject',
	0xB9: 'Random Play',
	0xBA: 'Select DisC',
	0xBB: 'Enter Disc',
	0xBC: 'Repeat',
	0xBD: 'Tracking',
	0xBE: 'Track Normal',
	0xBF: 'Slow Tracking',
	0xC0: 'Frame Forward',
	0xC1: 'Frame Back',
	0xC2: 'Mark',
	0xC3: 'Clear Mark',
	0xC4: 'Repeat From Mark',
	0xC5: 'Return To Mark',
	0xC6: 'Search Mark Forward',
	0xC7: 'Search Mark Backwards',
	0xC8: 'Counter Reset',
	0xC9: 'Show Counter',
	0xCA: 'Tracking Increment',
	0xCB: 'Tracking Decrement',
    0xCD: 'Play', // ?????
	0xE0: 'Volume',
	0xE1: 'Balance',
	0xE2: 'Mute',
	0xE3: 'Bass',
	0xE4: 'Treble',
	0xE5: 'Bass Boost',
	0xE6: 'Surround Mode',
	0xE7: 'Loudness',
	0xE8: 'MPX',
	0xE9: 'Volume Up',
	0xEA: 'Volume Down',
	0xF0: 'Speed Select',
	0xF1: 'Playback Speed',
	0xF2: 'Standard Play',
	0xF3: 'Long Play',
	0xF4: 'Extended Play',
	0xF5: 'Slow',
	0x100: 'Fan Enable',
	0x101: 'Fan Speed',
	0x102: 'Light',
	0x103: 'Light Illumination Level',
	0x104: 'Climate Control Enable',
	0x105: 'Room Temperature',
	0x106: 'Security Enable',
	0x107: 'Fire Alarm',
	0x108: 'Police Alarm',
	0x150: 'Balance Right',
	0x151: 'Balance Left',
	0x152: 'Bass Increment',
	0x153: 'Bass Decrement',
	0x154: 'Treble Increment',
	0x155: 'Treble Decrement',
	0x160: 'Speaker System',
	0x161: 'Channel Left',
	0x162: 'Channel Right',
	0x163: 'Channel Center',
	0x164: 'Channel Front',
	0x165: 'Channel Center Front',
	0x166: 'Channel Side',
	0x167: 'Channel Surround',
	0x168: 'Channel Low Frequency Enhancement',
	0x169: 'Channel Top',
	0x16A: 'Channel Unknown',
	0x170: 'Sub-channel',
	0x171: 'Sub-channel Increment',
	0x172: 'Sub-channel Decrement',
	0x173: 'Alternate Audio Increment',
	0x174: 'Alternate Audio Decrement',
	0x180: 'Application Launch Buttons',
	0x181: 'AL Launch Button Configuration Tool',
	0x182: 'AL Programmable Button Configuration',
	0x183: 'AL Consumer Control Configuration',
	0x184: 'AL Word Processor',
	0x185: 'AL Text Editor',
	0x186: 'AL Spreadsheet',
	0x187: 'AL Graphics Editor',
	0x188: 'AL Presentation App',
	0x189: 'AL Database App',
	0x18A: 'AL Email Reader',
	0x18B: 'AL Newsreader',
	0x18C: 'AL Voicemail',
	0x18D: 'AL Contacts/Address Book',
	0x18E: 'AL Calendar/Schedule',
	0x18F: 'AL Task/Project Manager',
	0x190: 'AL Log/Journal/Timecard',
	0x191: 'AL Checkbook/Finance',
	0x192: 'AL Calculator',
	0x193: 'AL A/V Capture/Playback',
	0x194: 'AL Local Machine Browser',
	0x195: 'AL LAN/WAN Browser',
	0x196: 'AL Internet Browser',
	0x197: 'AL Remote Networking/ISP Connect',
	0x198: 'AL Network Conference',
	0x199: 'AL Network Chat',
	0x19A: 'AL Telephony/Dialer',
	0x19B: 'AL Logon',
	0x19C: 'AL Logoff',
	0x19D: 'AL Logon/Logoff',
	0x19E: 'AL Terminal Lock/Screensaver',
	0x19F: 'AL Control Panel',
	0x1A0: 'AL Command Line Processor/Run',
	0x1A1: 'AL Process/Task Manager',
	0x1A2: 'AL Select Tast/Application',
	0x1A3: 'AL Next Task/Application',
	0x1A4: 'AL Previous Task/Application',
	0x1A5: 'AL Preemptive Halt Task/Application',
	0x200: 'Generic GUI Application Controls',
	0x201: 'AC New',
	0x202: 'AC Open',
	0x203: 'AC Close',
	0x204: 'AC Exit',
	0x205: 'AC Maximize',
	0x206: 'AC Minimize',
	0x207: 'AC Save',
	0x208: 'AC Print',
	0x209: 'AC Properties',
	0x21A: 'AC Undo',
	0x21B: 'AC Copy',
	0x21C: 'AC Cut',
	0x21D: 'AC Paste',
	0x21E: 'AC Select All',
	0x21F: 'AC Find',
	0x220: 'AC Find and Replace',
	0x221: 'AC Search',
	0x222: 'AC Go To',
	0x223: 'AC Home',
	0x224: 'AC Back',
	0x225: 'AC Forward',
	0x226: 'AC Stop',
	0x227: 'AC Refresh',
	0x228: 'AC Previous Link',
	0x229: 'AC Next Link',
	0x22A: 'AC Bookmarks',
	0x22B: 'AC History',
	0x22C: 'AC Subscriptions',
	0x22D: 'AC Zoom In',
	0x22E: 'AC Zoom Out',
	0x22F: 'AC Zoom',
	0x230: 'AC Full Screen View',
	0x231: 'AC Normal View',
	0x232: 'AC View Toggle',
	0x233: 'AC Scroll Up',
	0x234: 'AC Scroll Down',
	0x235: 'AC Scroll',
	0x236: 'AC Pan Left',
	0x237: 'AC Pan Right',
	0x238: 'AC Pan',
	0x239: 'AC New Window',
	0x23A: 'AC Tile Horizontally',
	0x23B: 'AC Tile Vertically',
	0x23C: 'AC Format',
};

const genericMap = {
	0x00: 'Undefined',
	0x01: 'Pointer',
	0x02: 'Mouse',
	0x03: 'Reserved',
	0x04: 'Joystick',
	0x05: 'Game Pad',
	0x06: 'Keyboard',
	0x07: 'Keypad',
	0x08: 'Multi-axis Controller',
	0x30: 'X',
	0x31: 'Y',
	0x32: 'Z',
	0x33: 'Rx',
	0x34: 'Ry',
	0x35: 'Rz',
	0x36: 'Slider',
	0x37: 'Dial',
	0x38: 'Wheel',
	0x39: 'Hat Switch',
	0x3A: 'Counted Buffer',
	0x3B: 'Byte Count',
	0x3C: 'Motion Wakeup',
	0x40: 'Vx',
	0x41: 'Vy',
	0x42: 'Vz',
	0x43: 'Vbrx',
	0x44: 'Vbry',
	0x45: 'Vbrx',
	0x46: 'Vno',
	0x80: 'System Control',
	0x81: 'System Power Down',
	0x82: 'System Sleep',
	0x83: 'System Wake Up',
	0x84: 'System Context Menu',
	0x85: 'System Main Menu',
	0x86: 'System App Menu',
	0x87: 'System Menu Help',
	0x88: 'System Menu Exit',
	0x89: 'System Menu Select',
	0x8A: 'System Menu Right',
	0x8B: 'System Menu Left',
	0x8C: 'System Menu Up',
	0x8D: 'System Menu Down',
	0x90: 'D-pad Up',
	0x91: 'D-pad Down',
	0x92: 'D-pad Right',
	0x93: 'D-pad Left',
};

export {
    keyboardMap,
    keyboardModifiers,
    consumerMap,
    genericMap,
};



// WEBPACK FOOTER //
// ./src/hid.js